import React, { useEffect, useState } from "react";
import { getCapabilities } from "../api/capabilityService";
import { sleep } from "../utils/sleep";
import * as FaIcons from 'react-icons/fa';

const WhyUsSection = () => {

  const [capabilities, setCapabilities] = useState([]);
            const [loading, setLoading] = useState(true);
            const [error, setError] = useState(null);
          
              useEffect(() => {
              const fetchCapabilities = async () => {
                try {
                  // simulate network delay (3 sec)
                  //await sleep(3000);
          
                  const data = await getCapabilities(); // asynchronous call
                  setCapabilities(data);
                } catch (err) {
                  setError("Failed to load capabilities.");
                } finally {
                  setLoading(false);
                }
              };
          
              fetchCapabilities();
              }, []);
            
            // Loading Overlay
            if (loading) {
              return (
                <div className="loading-overlay d-flex align-items-center justify-content-center py-5">
                  <div className="spinner-border text-primary" role="status"></div>
                  <span className="ms-3 fw-semibold">Loading capabilities...</span>
                </div>
              );
            }
            
             // Error Message
            if (error) {
              return (
                <div className="error-container d-flex flex-column align-items-center justify-content-center py-5">
                  <p className="text-danger fs-7">{error}</p>
                  <button
                    className="btn btn-outline-primary mt-3"
                    onClick={() => window.location.reload()}
                  >
                    Retry
                  </button>
                </div>
              );
      }
  
  return (
    <section className="py-5 bg-white">
      <div className="container text-center">
        <h2 className="fw-bold mb-4">
          Why Choose <span className="text-primary-color">Softition</span>?
        </h2>
        <p className="text-muted mb-5">
  We stand out for our commitment to quality, innovation, and delivering solutions that exceed expectations.
</p>
              <div className="d-flex flex-wrap justify-content-center gap-4">
                  {capabilities.map((item, idx) => {
                      const IconComponent = FaIcons[item.iconName];
                      return (
                          <div
                              key={idx}
                              className="why-card d-flex align-items-center px-4 py-3">
                              <div className="icon text-secondary-color fs-3">{IconComponent && <IconComponent />}</div>
                              <h6 className="mb-0 fw-semibold">{item.text}</h6>
                          </div>
                      )
                  })}
        </div>
      </div>
    </section>
  );
};

export default WhyUsSection;
